import React from "react";
import { Context } from "../../context";
import HTMLParser from "../../htmlParser";
const Button = ({ outerHTML }) => {
    if (!outerHTML)
        return React.createElement(React.Fragment, null);
    const { allPdf } = React.useContext(Context);
    const regex = new RegExp(`href="(.+\\.pdf)"`);
    const match = regex.exec(outerHTML); /** Renvoie array | null */
    if (match && allPdf?.edges.length) {
        try {
            const targetFile = allPdf.edges.find((e) => e?.node?.url.includes(match[1]));
            if (targetFile)
                outerHTML = outerHTML.replace(match[1], targetFile.node.publicURL);
        }
        catch (e) {
            console.error(e);
        }
    }
    return React.createElement(HTMLParser, null, outerHTML);
};
export default Button;
